import { createSelector } from 'reselect';

const myFavouritePassengersDomain = state => state.myFavouritePassengers;

export const myFavouritePassengersIsFetchingSelector = createSelector(
  myFavouritePassengersDomain,
  domain => domain.isFetching,
);

export const myFavouritePassengersPassengersSelector = createSelector(
  myFavouritePassengersDomain,
  domain => domain.passengers,
);



// WEBPACK FOOTER //
// ./src/containers/FavouritePassengers/selectors.js